import JobLeftDrawerContainer from "../../../components/job/other/JobLeftDrawer";

const JobLeftDrawer = () => {
  return <JobLeftDrawerContainer />;
};

export default JobLeftDrawer;
